import {staticFile} from 'remotion';
import type {CaptionFontDef} from '../../../../src/lib/caption-fonts';

const pendingFonts = new Map<string, Promise<void>>();

function fontFormat(file: string): string {
  const extension = file.toLowerCase().split('.').pop();
  if (extension === 'woff2' || extension === 'woff') return extension;
  if (extension === 'otf') return 'opentype';
  return 'truetype';
}

/** Resolve every request in its own Remotion context: native private bundles can use a nonce base. */
export function loadCinematicCaptionFont(
  def: CaptionFontDef,
  resolveStaticFile: (file: string) => string = staticFile,
): Promise<void> {
  if (!def.family) return Promise.resolve();
  if (!def.file) return Promise.reject(new Error(`그래픽 글꼴 파일이 없습니다: ${def.id}`));
  const url = resolveStaticFile(def.file);
  const weight = String(def.weight ?? 400);
  const key = JSON.stringify([url, def.family, weight]);
  const existing = pendingFonts.get(key);
  if (existing) return existing;

  const loading = (async () => {
    if (typeof document === 'undefined' || typeof FontFace === 'undefined' || !document.fonts) {
      throw new Error('그래픽 글꼴을 로드할 수 있는 브라우저 환경이 아닙니다.');
    }
    const face = new FontFace(def.family!, `url(${JSON.stringify(url)}) format("${fontFormat(def.file!)}")`, {weight});
    await face.load();
    document.fonts.add(face);
  })().catch((cause: unknown) => {
    throw new Error(`그래픽 글꼴을 불러오지 못했습니다: ${def.label} (${url})`, {cause});
  });
  pendingFonts.set(key, loading);
  void loading.catch(() => {
    if (pendingFonts.get(key) === loading) pendingFonts.delete(key);
  });
  return loading;
}
